module.exports = __webpack_public_path__ + "img/top-list-left3.e9e26973.png";